/**
 * Created by Gaplo917 on 3/9/2017.
 */
import * as PIXI from 'pixi.js'
import TWEEN from "@tweenjs/tween.js"
import Scene from "../objects/Scene"
import R from "../config/R"
import FullScreenBg from "../objects/FullScreenBg"
import * as Events from "../Events"
import * as _ from "lodash"
import SoundManager from "../SoundManager"
import Button from "../objects/Button"
import {BannerText} from "../characters/common/BannerText";
import {Timer} from "../characters/common/Timer";
import QuestionController from "../controllers/QuestionController";
import QuestionBox from "../characters/common/QuestionBox";
import LifeBarController from "../controllers/LifeBarController";
import Heart from "../characters/common/Heart";
import Image from "../objects/Image";
import {Man} from "../characters/common/Man";
import {Key} from "../characters/level2/Key";
import * as Rx from 'rxjs'
import {SpeechBubble} from "../characters/common/SpeechBubble";
import {CheckPointArrow} from "../characters/common/CheckPointArrow"
import InfoScene from "./InfoScene"
import {Door} from "../characters/common/Door"
import {Wood} from "../characters/level2/Wood"
import {Pecker} from "../characters/level2/Pecker"
import {Indian} from "../characters/level2/Indian"
import {Beacon} from "../characters/level2/Beacon"
import {BirdTower} from "../characters/level2/BirdTower"
import {Arrows} from "../characters/level2/Arrows"
import {Grass} from "../characters/level2/Grass";

const GameState = {
  ANSWER_CORRECT:                     "ANSWER_1_CORRECT",
  ANSWER_WRONG:                       "ANSWER_1_WRONG",
  PASS_GAME:                          "PASS_GAME",
  LOSE_GAME:                          "LOSE_GAME",
  CHECKPOINT_1:                       1,
  CHECKPOINT_2:                       2,
  CHECKPOINT_3:                       3,
  CHECKPOINT_4:                       4,
}

const END_GAME = 3

export class LevelScene2 extends Scene {
  constructor(resources, settings) {
    super()
    SoundManager.instance.stopBackground()

    this.resources = resources
    this.settings = settings
    this.passedLevel = settings.passedLevel + 1

    const questionController = new QuestionController(R.settings.level2Settings)
    questionController.prepareQuestions()

    const hearts = [0,1,2].map(i => {
      return new Heart(i * 120 + 1330, 100, resources)
    })

    const bg = new FullScreenBg(resources[R.images.level2_bg.name].texture)
    const grass = new Grass(500, 1200, resources)
    const bannerText = new BannerText(100, 55, "請判斷哪個量詞用得恰當？", resources)
    const restartBtn = new Button(1940,1450, resources[R.images.returnBtn.name].texture)
    const timer = new Timer(1790, 100, resources)
    const questionBox = new QuestionBox(600, 200, questionController.questions, resources, R.settings.level2Settings.level)
    const lifeBarController = new LifeBarController(hearts, 3)
    const heartBox = new Image(1450, 100, resources[R.images.heartBox.name].texture)
    const door = new Door(2150, 920, resources)

    // const startptArrow = new CheckPointArrow(600, 300, -2.5, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow1 = new CheckPointArrow(600, 300, -2.5, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow2 = new CheckPointArrow(1480, 200, -2.5, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow3 = new CheckPointArrow(1050, 800, -1.6, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow4 = new CheckPointArrow(750, 950, -1.6, resources[R.images.checkPointArrow.name].texture)

    //animation
    const bubble = new SpeechBubble(500, 900, resources)
    const man = new Man(280, 1250, resources)
    const key = new Key(1300, 1200, resources)
    const wood = new Wood(700, 1300, resources)
    const pecker = new Pecker(1760, 500, resources)
    const indian1 = new Indian(1300, 1250, resources, true)
    const indian2 = new Indian(1600, 1250, resources)
    const indian3 = new Indian(1900, 1250, resources)
    const birdTower = new BirdTower(768, 645, resources)
    const beacon = new Beacon(1130, 576, resources)
    const arrows = new Arrows(2500, -1000, resources)

    this.addChild(bg)
    this.addChild(grass)
    this.addChild(bubble)
    this.addChild(bannerText)
    this.addChild(beacon)
    // this.addChild(startptArrow)
    this.addChild(chkptArrow1)
    this.addChild(chkptArrow2)
    this.addChild(chkptArrow3)
    this.addChild(chkptArrow4)
    this.addChild(pecker)
    this.addChild(indian1)
    this.addChild(indian3)
    this.addChild(indian2)
    this.addChild(door)
    this.addChild(birdTower)
    this.addChild(key)
    this.addChild(questionBox)
    this.addChild(wood)
    this.addChild(arrows)
    this.addChild(man)
    this.addChild(timer)
    this.addChild(heartBox)
    this.addChild(restartBtn)
    hearts.forEach(_ => this.addChild(_))

    this.currentCheckPoint = 0
    this.questionBox = questionBox
    this.questionController = questionController
    this.timer = timer
    this.lifeBarController = lifeBarController
    this.man = man
    this.key = key
    // this.startptArrow = startptArrow
    this.chkptArrow1 = chkptArrow1
    this.chkptArrow2 = chkptArrow2
    this.chkptArrow3 = chkptArrow3
    this.chkptArrow4 = chkptArrow4
    this.door = door
    this.wood = wood
    this.pecker = pecker
    this.indian1 = indian1
    this.indian2 = indian2
    this.indian3 = indian3
    this.birdTower = birdTower
    this.beacon = beacon
    this.arrows = arrows

    this.schedulePlayStartGameVO = setTimeout(() => {
      this.playStartGameVO(() => {

        SoundManager.instance.playBackground(R.sounds.bg_6bg1_bg2)

        const t0 = timer.flashing()
        const t1 = bubble.appear()
        const t2 = bubble.disappear()
        const t3 = new TWEEN.Tween()
          .onComplete(() => {
            timer.start()
            this.questionBox.enableQuestionBox()
            // startptArrow.flashing()
            // birdTower.addOnClickListener(() => {
            //   timer.start()
            //   this.questionBox.enableQuestionBox()
            //   startptArrow.remove()
            // })
          })
        t0.chain(t1)
        t1.chain(t2)
        t2.chain(t3)
        t0.start()
      })
    }, 1500)

    restartBtn.displayGroup = new PIXI.DisplayGroup(9, true)
    restartBtn.addOnClickListener(() => {
      this.backToSelection()
    })

    this.setUpEventHandling()
  }

  playStartGameVO(cb){
    return SoundManager.instance.playEffect(R.sounds.pth_6b_g1_vo04, cb)
  }

  setUpEventHandling(){
    Events.hub.getEventStream(Events.ANSWERED)
      .throttleTime(500 /* ms */)
      .filter(() => this.timer.value > 0)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(({ choice, answer }) => {

        const isCorrect = this.questionController.isCorrect(choice, answer)

        if (isCorrect) {
          this.changeGameStateTo(GameState.ANSWER_CORRECT, {})
        } else {
          this.changeGameStateTo(GameState.ANSWER_WRONG, {})
        }
      })

    Events.hub.getEventStream(Events.NO_LIFE_LEFT)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .filter(() => this.timer.value > 0)
      .subscribe(() => {
        this.man.isLoseAndHoldPos = true
        this.changeGameStateTo(GameState.LOSE_GAME, {})
      })

    Events.hub.getEventStream(Events.TIMES_UP)
      .take(1)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.man.isLoseAndHoldPos = true
        this.man.unhappy()
        this.changeGameStateTo(GameState.LOSE_GAME, {})
      })

    Events.hub.getEventStream(Events.MEET_CHECKPOINT)
      .do(() => {
        this.currentCheckPoint = this.currentCheckPoint + 1
        if(this.currentCheckPoint === GameState.CHECKPOINT_4){
          this.timer.stop()
        }
      })
      .delay(1500)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .filter(() => this.timer.value > 0)
      .subscribe(() => {
        //
        this.questionBox.disableQuestionBox()
        this.changeGameStateTo(this.currentCheckPoint, {})
      })

    Events.hub.getEventStream(Events.ENABLE_QUESTION_BOX)
      .delay(2000)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .filter(() => this.timer.value > 0)
      .subscribe(() => {
          this.questionBox.enableQuestionBox()
      })


    Events.hub.getEventStream(Events.STOP_TIMER)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.timer.stop()
      })

    Events.hub.getEventStream(Events.DECREASE_LIFE)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .filter(() => this.timer.value > 0)
      .subscribe(() => {
        this.lifeBarController.decrement()
      })

    Events.hub.getEventStream(Events.END_GAME)
      .take(1)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.changeGameStateTo(GameState.PASS_GAME, {})
      })
  }

  changeGameStateTo(state, data){
    if (state === GameState.ANSWER_CORRECT){
      SoundManager.instance.playEffect(R.sounds.correct)
      console.log('the answer is correct')
      this.questionBox.disableQuestionBox({ isVisible: true})

      if (!this.questionController.isMeetCheckPoint()){
        if(!this.questionBox.isLastQuestion()){
          Rx.Observable.of(0)
            .delay(R.delay.afterAnswerEachQuestion)
            .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
            .subscribe(() => {
              this.questionBox.enableQuestionBox()
              this.questionBox.nextQuestion()
            })
        }
      }
    }
    else if (state === GameState.ANSWER_WRONG) {
      SoundManager.instance.playEffect(R.sounds.wrong)
      console.log('the answer is wrong')
      this.questionBox.disableQuestionBox()
      this.arrows.shooting()
      Rx.Observable.of(0)
        .delay(1500)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.man.onShoot()
        })
    }
    else if (state === GameState.CHECKPOINT_1) {

      this.chkptArrow1.flashing()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.birdTower.addOnClickListener(() => {
            this.chkptArrow1.remove()
            const r0 = this.birdTower.rebuild()
            const r1 = this.beacon.firing()

            r0.flatMap(() => r1)
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe(() => {
                Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
              })
          })
        })
    }
    else if (state === GameState.CHECKPOINT_2) {

      this.chkptArrow2.flashing()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.pecker.addOnClickListener(() => {
            this.chkptArrow2.remove()

            const r0 = this.pecker.pecking()
            const r1 = this.wood.appear()
            const r2 = this.wood.peckingByPecker()

            r0.flatMap(() => r1)
              .flatMap(() => r2)
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe(() => {
                Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
              })
          })
        })
    }
    else if (state === GameState.CHECKPOINT_3) {

      this.chkptArrow3.flashing()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.wood.addOnClickListener(() => {
            this.chkptArrow3.remove()

            const r0 = this.wood.cutting()
            r0
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe(() => {
                Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
              })
          })
        })
    }
    else if (state === GameState.CHECKPOINT_4) {

      this.chkptArrow4.flashing()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.wood.addOnClickListener(() => {
            this.chkptArrow4.remove()

            this.indian1.happy()
            this.indian2.happy()
            this.indian3.happy()

            this.key.openDoor()
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe()

            const r0 = this.wood.onFire()
            const r1 = this.door.appearing()
            const r2 = this.man.walking()

            r0.flatMap(() => r1)
              .delay(2000)
              .flatMap(() => r2)
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe(() => {
                Events.hub.publishEvent(Events.END_GAME, {})
              })
          })
        })
    }
    else if (state === GameState.PASS_GAME) {
      this.timer.stop()
      this.questionBox.disableQuestionBox()

      switch(this.passedLevel) {
        case END_GAME :
          this.endGame()
          break
        default :
          SoundManager.instance.playEffect(R.sounds.sfx_clap)
          SoundManager.instance.playEffect(R.sounds.pass_level2, () => {
            this.popUpInfoScene(this.resources[R.images.success_02.name].texture)
            SoundManager.instance.playEffect(R.sounds.pth_6b_g1_vo09, () => {
              Rx.Observable.of(0)
                .delay(4000)
                .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
                .subscribe(() => {
                  this.nextScene()
                })
            })
          })
      }
    }
    else if (state === GameState.LOSE_GAME) {
      this.timer.stop()
      this.questionBox.disableQuestionBox()
      SoundManager.instance.playEffect(R.sounds.fail_level1, () => {
        this.popUpInfoScene(this.resources[R.images.fail_02.name].texture)
        SoundManager.instance.playEffect(R.sounds.pth_6b_g1_vo08, () => {
          Rx.Observable.of(0)
            .delay(4000)
            .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
            .subscribe(() => {
              this.playAgain()
            })
        })
      })
    }
  }

  stop(){
    this.timer.stop()
  }

  destroy(){
    TWEEN.removeAll()
    this.timer.stop()
    clearTimeout(this.schedulePlayStartGameVO)
    super.destroy({children: true})
  }

  backToSelection(){
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.SELECTION })
  }

  playAgain(){
    this.destroy()
    this.passedLevel = this.passedLevel - 1
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.LEVEL_2, data : { passedLevel : this.passedLevel }})
  }

  popUpInfoScene(texture){
    this.infoScene = new InfoScene(this.resources, texture)
    this.addChild(this.infoScene)
  }

  nextScene(){
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.LEVEL_3, data : { passedLevel : this.passedLevel } })
  }

  endGame(){
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.END_GAME })
  }
}



// WEBPACK FOOTER //
// ./src/game/scenes/LevelScene2.js